import { useEffect } from 'react';

/**
 * Hook that restores a saved ProductReceptionsDrawer state from sessionStorage on mount.
 * When the user navigates away (to open a reception / order) and then comes back,
 * the drawer re-opens automatically on the same product and period.
 *
 * Usage:
 *   useDrawerRestore(setDrawerTarget, location.pathname);
 */
export default function useDrawerRestore(setDrawerTarget) {
    useEffect(() => {
        try {
            const raw = sessionStorage.getItem('pendingDrawerReopen');
            if (!raw) return;
            const saved = JSON.parse(raw);
            if (!saved) return;
            if (saved.returnPath && saved.returnPath.split('?')[0] !== window.location.pathname) {
                return; // not the page that opened the drawer
            }
            setDrawerTarget({
                industrial_product_id: saved.industrial_product_id,
                supplier_product_id: saved.supplier_product_id,
                productName: saved.productName,
                subtitle: saved.subtitle,
            });
            sessionStorage.removeItem('pendingDrawerReopen');
        } catch { /* ignore */ }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
